module.exports = __webpack_public_path__ + "static/media/tour-compl-0.52b52f3e.png";